import { Customer } from "src/app/models/customer.model";

export function getCustomerInitials(customer: Customer){
  let out = ""

  if(customer.firstName){
    out += customer.firstName.charAt(0)
  }

  if(customer.lastName){
    out += customer.lastName.charAt(0)
  }

  return out
}

export function hashStringToNumber(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32bit integer
  }
  return hash - 1000
}

export function stringToHexColor(str: string): string {
  const hash = hashStringToNumber(str);
  // Convert the hash number to a hex string
  let color = ((hash >> 24) & 0xFF).toString(16) +
              ((hash >> 16) & 0xFF).toString(16) +
              ((hash >> 8) & 0xFF).toString(16) +
              (hash & 0xFF).toString(16);
  // Ensure it's 6 characters long
  color = color.padStart(6, '0');
  // Return the hex color with a leading '#'
  return `#${color.substring(0, 6)}`;
}